// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function GameControllerIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M22 14h-3a1 1 0 0 1 0-2h3a1 1 0 0 1 0 2Zm-9-2h-1v-1a1 1 0 0 0-2 0v1H9a1 1 0 0 0 0 2h1v1a1 1 0 0 0 2 0v-1h1a1 1 0 0 0 0-2Zm17.185 13.081a4.5 4.5 0 0 1-6.911.555L18.31 20h-4.625l-4.959 5.636-.044.047a4.5 4.5 0 0 1-7.612-3.964V21.7L3.116 11.19A7.485 7.485 0 0 1 10.486 5H21.5a7.51 7.51 0 0 1 7.375 6.156v.023L30.921 21.7v.018a4.466 4.466 0 0 1-.736 3.363ZM21.5 18a5.5 5.5 0 0 0 0-11H10.486a5.487 5.487 0 0 0-5.401 4.546v.017l-2.047 10.51a2.5 2.5 0 0 0 4.212 2.215l5.24-5.95a1 1 0 0 1 .75-.338h8.26Zm7.462 4.074-1.092-5.625A7.5 7.5 0 0 1 21.5 20h-.525l3.775 4.289a2.51 2.51 0 0 0 2.183.673 2.5 2.5 0 0 0 2.028-2.888h.002Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
